import axios from "axios";
import { toast } from "react-toastify";
export const GetCompanyInfo = (data) => {
  return {
    type: "Get_Company_Info",
    payload: data,
    loader: false,
  };
};
export function getCompanyInfo() {
  return (dispatch) => {
    axios({
      url: `${process.env.REACT_APP_API_URL}Company`,
      method: "get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "content-type": "application/json",
      },
    }).then(
      (result) => {
        if (result.data.IsSuccess === true) {
          dispatch(GetCompanyInfo(result.data.Data));
        } else {
          toast.info(result.data.Message);
        }
      },
      (error) => {
        toast.info("Something went wrong!");
      }
    );
  };
}
